import { UNGROUPED_KEY } from './constants';
export const isEqualOptions = (a, b) => a.value === b.value && a?.active === b?.active;
export const groupOptions = (options) => {
    const grouped = new Map();
    options.forEach((option) => {
        const groupName = option.group || UNGROUPED_KEY;
        if (!grouped.has(groupName)) {
            grouped.set(groupName, []);
        }
        grouped.get(groupName).push(option);
    });
    // Convert to array and sort groups (ungrouped items first if they exist)
    const groups = [];
    // Add ungrouped items first
    if (grouped.has(UNGROUPED_KEY)) {
        groups.push({
            groupName: UNGROUPED_KEY,
            options: grouped.get(UNGROUPED_KEY),
        });
        grouped.delete(UNGROUPED_KEY);
    }
    // Add other groups in alphabetical order
    const sortedGroupNames = Array.from(grouped.keys()).sort((a, b) => a.localeCompare(b));
    sortedGroupNames.forEach((groupName) => {
        groups.push({
            groupName,
            options: grouped.get(groupName),
        });
    });
    return groups;
};
export const hasGroups = (options) => options.some((option) => option.group !== undefined);
